export default __webpack_public_path__ + "static/media/title-deco-right.f2fc12f4.webp";